import { z } from 'zod';
export const API_KEY_SCOPES = ['leads:write', 'leads:read', 'contacts:write', 'activities:write', 'tasks:write'];
export const createApiKeySchema = z.object({
    name: z.string().trim().min(1).max(100),
    scopes: z.array(z.enum(API_KEY_SCOPES)).min(1),
    expiresAt: z.string().datetime().optional(),
});
export const apiKeyResponseSchema = z.object({
    id: z.string().uuid(),
    name: z.string(),
    prefix: z.string(),
    scopes: z.array(z.string()),
    createdByName: z.string().nullable(),
    expiresAt: z.string().datetime().nullable(),
    lastUsedAt: z.string().datetime().nullable(),
    revokedAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
/** Returned exactly once, at creation (docs section 27 Security — never
 * shown again, never recoverable). */
export const createApiKeyResponseSchema = apiKeyResponseSchema.extend({
    secret: z.string(),
});
//# sourceMappingURL=schemas.js.map